export const isDependencyCheckFails = (field, data, fields) => {
  if (field.dependsOn) {
    if (Array.isArray(data[field.dependsOn])) {
      if (!data[field.dependsOn].includes(field.condition)) return false;
    } else {
      if (field.condition.toString() != data[field.dependsOn]?.toString()) return false;
      const dependsOnField = fields?.find((f) => f.name == field.dependsOn);
      if (dependsOnField?.dependsOn) {
        if (dependsOnField.condition.toString() != data[dependsOnField.dependsOn]?.toString()) {
          return false;
        } else {
          return isDependencyCheckFails(dependsOnField, data, fields);
        }
      }
    }
  }
  return true;
};
